<template>
  <div>
    <b-row>

      <b-col md="12" class="d-flex align-items-center justify-content-between mb-1">
        <span class="text-muted" style="font-size:0.78rem;">Los campos con * son obligatorios</span>
      </b-col>

      <b-col md="12">
        <b-form-group label="Nombre *" label-size="sm">
          <b-form-input v-model="form.name"
                        size="sm"
                        placeholder="Nombre de la categoría"
                        ref="inputName"
                        @keyup.enter.native="save()"
                        :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="12" class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$emit('cancel')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="dark" size="sm" @click="save()" :disabled="loading || !form.name.trim()">
          <AppIcon icon="check" class="mr-1"></AppIcon>
          Guardar
        </b-button>
      </b-col>

    </b-row>
  </div>
</template>
<script>
  import serviceAPI from '../services'

  const emptyForm = () => ({ name: '' })

  export default {
    props: {
      item: { type: Object, default: null },
    },
    data() {
      return {
        form: emptyForm(),
        loading: false,
      }
    },
    watch: {
      item: {
        immediate: true,
        handler(val) {
          if (val) {
            this.loadForEdit(val.id)
          } else {
            this.form = emptyForm()
          }
        },
      },
    },
    mounted() {
      this.$nextTick(() => { if (this.$refs.inputName) this.$refs.inputName.focus() })
    },
    methods: {
      loadForEdit(id) {
        this.loading = true
        serviceAPI.obtenerCategoriaCompra(id)
          .then((r) => { this.form = Object.assign(emptyForm(), r.data) })
          .finally(() => { this.loading = false })
      },
      save() {
        if (!this.form.name.trim()) return

        this.loading = true
        var isEdit = this.item && this.item.id
        var data = Object.assign({}, this.form, { name: this.form.name.trim() })

        var call = isEdit
          ? serviceAPI.editarCategoriaCompra(Object.assign({}, data, { id: this.item.id }))
          : serviceAPI.agregarCategoriaCompra(data)

        call
          .then((r) => {
            this.$awn.success(isEdit ? 'Categoría actualizada' : 'Categoría creada')
            this.$emit('saved', r.data)
          })
          .catch(() => { this.$awn.alert('Error al guardar la categoría') })
          .finally(() => { this.loading = false })
      },
    },
  }
</script>
